// extracted by mini-css-extract-plugin
export default {"button":"GenRxButton_button__+DYTQ","iconContainer":"GenRxButton_iconContainer__u17yx","icon":"GenRxButton_icon__7CWwD","text":"GenRxButton_text__+8Dl6"};